


















import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
@Component({
  computed: {
    ...mapGetters({
      columns: 'grid/getColumnLength',
      rows: 'grid/getRowLength',
      bombs: 'grid/getBombs'
    })
  },
  methods: {
    ...mapActions('setting', ['toggleSetting'])
  }
})
export default class Setting extends Vue {
}
